import React from "react";
import { Alert } from "reactstrap";
import { useScheduleAlerts } from "../../hooks/Dashboard/Schedule/useScheduleAlerts";

const ScheduleAlerts = (props) => {
  const {
    showEventsError,
    showTagsError,
    showExportError,
    formatErrorMessage,
    onClearEventsError,
    onClearTagsError,
    onClearExportError,
    eventsError,
    tagsError,
    exportError,
  } = useScheduleAlerts(props);
  return (
    <>
      {showEventsError && (
        <Alert color="danger" className="mt-3" toggle={onClearEventsError}>
          {formatErrorMessage(eventsError)}
        </Alert>
      )}
      {showTagsError && (
        <Alert color="warning" className="mt-3" toggle={onClearTagsError}>
          Failed to load tags. Some functionality may be limited.
        </Alert>
      )}
      {showExportError && (
        <Alert color="warning" className="mt-3" toggle={onClearExportError}>
          Failed to load export data.
        </Alert>
      )}
    </>
  );
};

export default ScheduleAlerts;
